import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "floating-item" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "unread-badge"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { ref, computed, getCurrentInstance, onMounted } from 'vue'
import YSF from "@neysf/qiyu-web-sdk";
import userService from '@/services/user'
import { useI18n } from 'vue-i18n';
import { ElMessage } from 'element-plus'
import useCommon from '@/composables/useCommon'
import { useStore } from 'vuex'
import { getToken } from '@/utils/auth'

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { getUserInfo } = userService
const store = useStore()
const {
  appContext: {
    config: { globalProperties }
  }
} = getCurrentInstance()
const lang = computed(() => store.state.user.language)
const { t } = useI18n();
const { JumpToHref } = useCommon()
const unreadCount = ref(0);

// 控制除关闭外的项是否显示（默认显示）
const isShowItems = ref(true);

// 悬浮按钮列表数据
const list = ref([
  {
    id: 1,
    name: `${t('msg.calculate.xskf')}`,
    icon: require('@/assets/images/icons/right_kf.png'),
  },
  {
    id: 2,
    name: `${t('msg.other.yf_ss')}`,
    icon: require('@/assets/images/icons/right_jisq.png'),
  },
  {
    id: 3,
    name: `${t('msg.calculate.scwz')}`,
    icon: require('@/assets/images/icons/right_sc.png'),
  },
  {
    id: 4,
    name: `${t('msg.calculate.top_back')}`,
    icon: require('@/assets/images/icons/right_top.png'),
  },
])

// 客服 SDK 实例（全局保存，避免重复初始化）
let customerInstance = null

/**
 * 初始化客服 SDK
 */
const initCustomerService = async () => {
  if (customerInstance) return customerInstance // 已初始化则直接返回

  try {
    // 初始化 SDK
    const ysf = await YSF.init('45656fef3487f900cbe100fb04c8057c', {
      sdkTemplateId: 8128650,
      templateId: 8128650,
      sessionInvite: false,
      hidden: 1
    })

    // 保存实例到全局
    globalProperties.$customer = ysf
    customerInstance = ysf
    ysf('onunread', (res) => {
      unreadCount.value = res.total
    })
    // 配置用户信息（如果已登入）
    const token = store.state.user.token || getToken()
    if (token) {
      try {
        const res = await getUserInfo()
        const userInfo = res.data.result
        store.dispatch('user/setUserInfo', userInfo)

        // 设置用户信息
        ysf('config', {
          uid: userInfo.user_id,
          nickname: `${userInfo.user_id}-买到手`,
          email: userInfo.email,
          mobile_phone: userInfo.mobile,
          data: JSON.stringify([
            { "key": "uid", "value": userInfo.user_id, "label": "UserId" },
            { "key": "nickname", "value": `${userInfo.user_id}-买到手`, "label": "昵称" },
            { "key": "mobile_phone", "value": userInfo.mobile, "label": "手机号码" },
            { "key": "email", "value": userInfo.email, "label": "邮箱" },
          ]),
          language: lang.value === 'zh-CN' ? 'zh-cn' : 'zh-tw',
        })
      } catch (err) {
        console.error('获取用户信息失败', err)
      }
    } else {
      // 未登入状态下仅配置语言
      ysf('config', {
        language: lang.value === 'zh-CN' ? 'zh-cn' : 'zh-tw'
      })
    }

    return ysf
  } catch (error) {
    console.error('客服 SDK 初始化失败', error)
    throw error // 抛出错误，方便调用处处理
  }
}

/**
 * 处理按钮点击事件
 * @param item 当前点击的按钮数据
 */
async function handleItemClick(item: { id: number; name: string; icon: any }) {
  switch (item.id) {
    case 1:
      // 线上客服：初始化并打开对话窗口
      try {
        const ysf = await initCustomerService()
        ysf('open') // 直接打开客服窗口
        unreadCount.value = 0
      } catch (error) {
        console.error('打开客服失败', error)
      }
      break;
    case 2:
      // 试算器逻辑
      JumpToHref("Calculate")
      break;
    case 3:
      // 显示提示，引导用户使用对应快捷键
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') !== -1;
      const shortcut = isMac ? 'Command + D' : 'Ctrl + D';
      ElMessage({
        message: `请使用快捷键 ${shortcut} 将本页添加到书签`,
        type: 'info',
        duration: 3000,
        showClose: true
      });
      break;
    case 4:
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      break;
    case 5:
      isShowItems.value = !isShowItems.value;
      item.icon = isShowItems.value
        ? require('@/assets/images/icons/close-circle.png')
        : require('@/assets/images/icons/expand-circle.png'); // 替换为你的展开图标
      break;
    default:
      break;
  }
}

// 页面加载时提前初始化客服 SDK（可选，优化点击响应速度）
onMounted(() => {
  initCustomerService().catch(() => {
    // 初始化失败不影响页面，点击时会再次尝试
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: _normalizeClass(["item", { 'item-hidden': !isShowItems.value && item.id !== 5 }]),
        onClick: ($event: any) => (handleItemClick(item))
      }, [
        (item.id === 1 && unreadCount.value > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(unreadCount.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          class: "icon",
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", {
          class: _normalizeClass(["name", { 'has-badge': item.id === 1 && unreadCount.value > 0 }])
        }, _toDisplayString(item.name), 3)
      ], 10, _hoisted_2))
    }), 128)),
    _createElementVNode("img", {
      class: "icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleItemClick({id: 5, name: '',icon:''}))),
      src: `${isShowItems.value? require('@/assets/images/icons/close-circle.png') : require('@/assets/images/icons/expand-circle.png')}`,
      alt: ""
    }, null, 8, _hoisted_5)
  ]))
}
}

})